import { render, staticRenderFns } from "./AlertaModal.vue?vue&type=template&id=78a55178"
import script from "./AlertaModal.vue?vue&type=script&lang=js"
export * from "./AlertaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports